import { React } from 'react';
import { Container } from 'react-bootstrap';
import { Account } from './Account/Account';
import { Password } from './Password/Password';
import { useUserContext } from 'contexts/UserContext';
import { useTranslation } from 'react-i18next';

export function UserProfile() {
    const { t } = useTranslation();
    const { userData } = useUserContext();

    const handleReseted = () => {
        alert(t('passwordChanged'));
    };

  if (!userData) return null;
 
  return (
      <Container className="mt-4" style={{ maxWidth: '480px' }}> 
              <h2>{t('prMyAccount')}</h2>
        <Account></Account>
              <Password handleReseted={handleReseted}></Password>        
      </Container>
  );
}
